import React from "react";
import DragNumberInput from "./DragNumberInput";

const AxisNumberInput = ({
  axis,
  wrapperClassName = "flex items-center gap-1",
  labelClassName = "text-xs text-gray-300 uppercase w-3 text-center",
  ...props
}) => {
  return (
    <DragNumberInput
      label={axis}
      wrapperClassName={`${wrapperClassName} property-axis-number-input`}
      labelClassName={`${labelClassName} property-axis-label`}
      {...props}
    />
  );
};

export default AxisNumberInput;
